<template>
	<div class="notice-content">
		<div class="setting-top-box">
			<span class="setting-top-title">系统消息</span>
		</div>
		<div class="notice-box">
			<ul class="notice-list">
				<li class="line-1" v-for="item in curData_" :key="item.id" @click="goDetail(item.id)">
					<span class="fr">{{item.releaseTimestamp | time}}</span>
					{{item.title}}
				</li>
			</ul>
			<ss-no-data v-if="finish_ && busy_ && curData_.length === 0" mode="image" text="暂无相关的信息" />
		</div>
		<div class="right-navigation-box">
			<ssNavigation v-if="pageTotal_ > pageSize" :total="pageTotal_" v-model="curPage" :size="pageSize" />
		</div>
	</div>
</template>

<script>
	import listMixin from '@/mixins/list.js'
	export default {
		mixins: [ listMixin ],
		methods: {
			goDetail(id) {
				this.$router.push({
					path: '/setting/notice/' + id
				})
			}
		}
	}
</script>

<style lang="scss">
	.notice-content{
		.notice-list{
			li{
				padding: 30px 0 36px 30px;
				font-size: 18px;
				font-weight: 400;
				color: #111010;
				line-height: 20px;
				position: relative;
				@include ellipsis();
				cursor: pointer;
				&::before{
					content: '';
					width: 7px;
					height: 7px;
					background: #1A70FE;
					@include abs(50%, null, null, 0);
					margin-top: -4px;
				}
				&:last-child::after{
					display: none;
				}
				span{
					font-size: 14px;
					font-weight: 400;
					color: #B9B9B9;
					line-height: 20px;
				}
			}
		}
		.notice-box{
			padding: 0 27px 0 23px;
			height: 887px;
			overflow: auto;
		}
	}
</style>
